import { isEmpty } from 'lodash-es';
import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { AutomatedEmailCampaignType } from 'wisestep-api';

import {
  ClientCampaign,
  ClientSpocCampaign,
  DefaultCampaign,
  JobCampaign,
  SourceCampaign,
} from '../../features';

export const CampaignRouter = () => {
  const [searchParams] = useSearchParams();
  const type = searchParams.get('type') as AutomatedEmailCampaignType;
  const id = searchParams.get('id');

  const componentMap: Record<AutomatedEmailCampaignType, React.ReactNode> = {
    [AutomatedEmailCampaignType.CLIENT]: <ClientCampaign disable={!isEmpty(id)} />,
    [AutomatedEmailCampaignType.JOB]: <JobCampaign disable={!isEmpty(id)} />,
    [AutomatedEmailCampaignType.CLIENT_SPOC]: <ClientSpocCampaign disable={!isEmpty(id)} />,
    [AutomatedEmailCampaignType.SOURCE]: <SourceCampaign disable={!isEmpty(id)} />,
    [AutomatedEmailCampaignType.DEFAULT]: <DefaultCampaign />,
  };

  return <>{componentMap[type]}</>;
};
